<template>
  <el-dialog v-el-drag-dialog
             :visible.sync="dialogVisible"
             :close-on-click-modal="false"
             title="打印工单"
             width="800px"
             height="600px">
    <div style="width: 700px;" id="printProductionContent">
      <div v-for="(productInfo,index) in productInfos" :key="index" id="printProductionCards">
        <table style="width: 100%;margin-top: 10px;" cellpadding="0" cellspacing="0">
          <tr>
            <td rowspan="3" style="width: 20%;">
              <div :id="(() => 'qrCode_'+productInfo.pkid)()" align="center"/>
            </td>
            <td colspan="3" style="text-align: center; font-weight: 700; font-size: 20px">工单</td>
          </tr>
          <tr>
            <td colspan="2" style="width: 40px;">派工单号：{{productInfo.billNo}}</td>
            <td>工单号：{{productInfo.productionOrderNo}}</td>
          </tr>
          <tr>
            <td colspan="2">物料名称：{{productInfo.materialName}}</td>
            <td>物料编号：{{productInfo.materialNo}}</td>
          </tr>
          <tr>
            <!--            <td style="width: 20%">工单类型：{{productInfo.prodOrderTypeName}}</td>-->
            <td colspan="3" style="height: 40px;font-size: 14px;">规格：{{productInfo.specification}}</td>
            <td>
              <div style="display: flex;">
                <div style="text-align: center;" :id="(() => 'barCodeM1_'+productInfo.pkid)()"/>
                <div style="margin-top: 18px;margin-left: 5px;font-size: 14px;">报错入口</div>
              </div>
              <!--              <div>-->
              <!--                <div :id="(() => 'barCodeM1_'+productInfo.pkid)()"/>-->
              <!--                <div style="text-align: center;margin-top: -4px;">报错入口</div>-->
              <!--              </div>-->
            </td>
          </tr>
          <tr>
            <td colspan="2">工艺路线：{{productInfo.routingName}}</td>
            <td>工单数量：{{productInfo.quantity}}</td>
            <td>工作中心：{{productInfo.workCenterName}}</td>
          </tr>
          <tr>
            <td colspan="2">开工时间：{{productInfo.planStartTime}}</td>
            <td colspan="2">完工时间：{{productInfo.planFinishTime}}</td>
          </tr>
          <tr>
            <td colspan="2">生产任务制单人：{{productInfo.productCreatorName}}</td>
            <td colspan="2">销售订单制单人：{{productInfo.orderCreatorName}}</td>
          </tr>
          <tr>
            <td colspan="2">销售单号：{{productInfo.salesOrderNo}}</td>
            <td colspan="2">ERP单号：{{productInfo.erpSalesOrderNo}}</td>
          </tr>
          <tr>
            <td colspan="2" style="width: 50%">合同号：{{productInfo.customerContractNo}}</td>
            <td colspan="2" style="width: 50%">项目名称：{{productInfo.projectName}}</td>
          </tr>
          <tr>
            <td colspan="2">客户名称：{{productInfo.customerName}}</td>
            <td colspan="2">最终客户：{{productInfo.finalCustomerName}}</td>
          </tr>
          <tr>
            <td colspan="4">订单备注：{{productInfo.salesOrderMaterialNote}}</td>
          </tr>
        </table>
        <!--        24.7-->
        <table style="width: 100%;margin-top: 10px;" cellpadding="0" cellspacing="0"
               v-if="productInfo.materialTypeNo==='24.7'">
          <tr>
            <td colspan="2" rowspan="2" style="text-align: center">生产首检</td>
            <td colspan="6">
              <span style="margin-left: 50px;">▢ OK</span>
              <span style="margin-left: 50px;">作业员：</span>
              <span style="margin-left: 100px;">生产日期：</span>
            </td>
          </tr>
          <tr>
            <td colspan="6">
              <span style="margin-left: 50px;">▢ NG</span>
              <span style="margin-left: 50px;">作业员：</span>
              <span style="margin-left: 100px;">生产日期：</span>
              <span style="margin-left: 100px;">NG描述：</span>
            </td>
          </tr>
          <tr>
            <td colspan="2" rowspan="2" style="text-align: center">品质首检</td>
            <td colspan="6">
              <span style="margin-left: 50px;">▢ OK</span>
              <span style="margin-left: 50px;">检验员：</span>
              <span style="margin-left: 100px;">生产日期：</span>
            </td>
          </tr>
          <tr>
            <td colspan="6">
              <span style="margin-left: 50px;">▢ NG</span>
              <span style="margin-left: 50px;">检验员：</span>
              <span style="margin-left: 100px;">生产日期：</span>
              <span style="margin-left: 100px;">NG描述：</span>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="text-align: center">生产工时记录</td>
            <td colspan="6"/>
          </tr>
          <tr>
            <td rowspan="3" width="20px">巡检人员</td>
            <td>巡检数量</td>
            <td colspan="6"/>
          </tr>
          <tr>
            <td>不合格数量</td>
            <td colspan="6"/>
          </tr>
          <tr>
            <td>不合格描述</td>
            <td colspan="6"/>
          </tr>
          <tr>
            <td colspan="8">
              <span>主管：</span>
              <span style="margin-left: 200px;">组长确认：</span>
              <span style="margin-left: 200px;">制单人：张红楠</span>
            </td>
          </tr>
        </table>
        <!--        24.6-->
        <table style="width: 100%;margin-top: 10px;" cellpadding="0" cellspacing="0"
               v-if="productInfo.materialTypeNo==='24.6'">
          <tr>
            <td rowspan="2" style="text-align: center">工序</td>
            <td><span>▢波纹电阻</span></td>
            <td>套箍</td>
            <td>绕丝</td>
            <td>点焊</td>
            <td>浸漆</td>
            <td/>
            <td>烘烤</td>
            <td>组装</td>
            <td/>
            <td/>
            <td/>
            <td>测试</td>
            <td/>
            <td>贴标</td>
            <td>包装</td>
          </tr>
          <tr>
            <td><span>▢铝壳电阻</span></td>
            <td>套箍</td>
            <td>绕丝</td>
            <td>点焊压接</td>
            <td>浸漆</td>
            <td>填衬敲砂</td>
            <td>烘烤</td>
            <td/>
            <td>修整</td>
            <td>装档片</td>
            <td>打标</td>
            <td>测试</td>
            <td>压接</td>
            <td>贴标</td>
            <td>包装</td>
          </tr>
          <tr>
            <td colspan="2" style="text-align: center">生产首检</td>
            <td v-for="n in 14">
              <!--              <span>▢OK</span><span>▢NG</span>-->
              <div style="text-align: center;">
                <span style="display :block;margin-bottom: 2px;">▢OK</span>
                <span style="display :block;margin-bottom: 2px;">▢NG</span>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="text-align: center">操作人员</td>
            <td v-for="n in 14"></td>
          </tr>
          <tr>
            <td colspan="2" style="text-align: center">生产日期</td>
            <td v-for="n in 14"></td>
          </tr>
          <tr>
            <td colspan="2" style="text-align: center">品质检验</td>
            <td colspan="3">
              <div style="text-align: center;">
                <span style="display :block;margin-bottom: 2px;">▢OK</span>
                <span style="display :block;margin-bottom: 2px;">▢NG</span>
              </div>
            </td>
            <td><span>--</span></td>
            <td>
              <div style="text-align: center;">
                <span style="display :block;margin-bottom: 2px;">▢OK</span>
                <span style="display :block;margin-bottom: 2px;">▢NG</span>
              </div>
            </td>
            <td><span>--</span></td>
            <td colspan="8">
              <div style="text-align: center;">
                <span style="display :block;margin-bottom: 2px;">▢OK</span>
                <span style="display :block;margin-bottom: 2px;">▢NG</span>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="text-align: center">检验员</td>
            <td colspan="3"/>
            <td><span>--</span></td>
            <td/>
            <td><span>--</span></td>
            <td colspan="8"/>
          </tr>
          <tr>
            <td colspan="2" style="text-align: center">检验日期</td>
            <td colspan="3"/>
            <td><span>--</span></td>
            <td/>
            <td><span>--</span></td>
            <td colspan="8"/>
          </tr>
          <tr>
            <td colspan="2" style="text-align: center">异常记录</td>
            <td colspan="14"/>
          </tr>
        </table>
        <!--        03.01 03.06 24.1 24.2-->
        <table style="width: 100%;margin-top: 2px;" cellpadding="0" cellspacing="0"
               v-if="productInfo.materialTypeNo==='03.01'||productInfo.materialTypeNo==='03.06'||productInfo.materialTypeNo==='24.1'||productInfo.materialTypeNo==='24.2'">
          <tr>
            <td style="text-align: center;padding: 0 !important;" colspan="3">工单交接签字</td>
            <td style="text-align: center;padding: 0 !important;">线/带规格</td>
            <td style="text-align: center;padding: 0 !important;">圈数</td>
            <td style="text-align: center;padding: 0 !important;">长度</td>
            <td style="text-align: center;padding: 0 !important;">人员</td>
          </tr>
          <tr>
            <td style="text-align: center;padding: 0 !important;">日期</td>
            <td style="text-align: center;padding: 0 !important;">数量</td>
            <td style="text-align: center;padding: 0 !important;">人员</td>
            <td/>
            <td/>
            <td/>
            <td/>
          </tr>
          <tr>
            <td/>
            <td/>
            <td/>
            <td/>
            <td/>
            <td/>
            <td/>
          </tr>
          <tr>
            <td/>
            <td/>
            <td/>
            <td style="text-align: center;padding: 0 !important;" colspan="4">气隙分布图</td>
          </tr>
          <tr>
            <td/>
            <td/>
            <td/>
            <td colspan="4" rowspan="7" style="text-align: center;width: 220px;">
              <!--              <el-image :src="qixiUrl" style="width: 200px;height: 200px;" fit="fill"/>-->
              <div>
                <div style="width: 100%;text-align: center;" v-for="n in 11">
                  <img :src="qixiUrl" style="width:110px;">
                  <img :src="qixiUrl" style="width:110px;margin-left: 30px;">
                  <img :src="qixiUrl" style="width:110px;margin-left: 30px;">
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td style="text-align: center" colspan="3">品质确认签字</td>
          </tr>
          <tr>
            <td colspan="2"/>
            <td/>
          </tr>
          <tr>
            <td colspan="2"/>
            <td/>
          </tr>
          <tr>
            <td colspan="2"/>
            <td/>
          </tr>
          <tr>
            <td style="text-align: center" colspan="3">入库批次记录</td>
          </tr>
          <tr>
            <td>日期</td>
            <td>数量</td>
            <td>人员</td>
          </tr>
          <tr>
            <td/>
            <td/>
            <td/>
            <td style="text-align: center ;padding: 0 !important;" colspan="4">芯柱纸长度</td>
          </tr>
          <tr>
            <td/>
            <td/>
            <td/>
            <td style="text-align: center;padding: 0 !important;">绝缘纸规格</td>
            <td style="text-align: center;padding: 0 !important;">长度</td>
            <td colspan="2"/>
          </tr>
          <tr>
            <td/>
            <td/>
            <td/>
            <td/>
            <td/>
            <td colspan="2"/>
          </tr>
          <tr>
            <td/>
            <td/>
            <td/>
            <td style="text-align: center;padding: 0 !important;">垫板规格</td>
            <td style="text-align: center;padding: 0 !important;">数量</td>
            <td colspan="2"/>
          </tr>
          <tr>
            <td/>
            <td/>
            <td/>
            <td/>
            <td/>
            <td colspan="2"/>
          </tr>
          <tr>
            <td/>
            <td/>
            <td/>
            <td/>
            <td/>
            <td colspan="2"/>
          </tr>
          <tr>
            <td style="padding: 0 !important;" colspan="7" rowspan="2">
              备注：1.需要确认操作卡图片与实物不一致情况--报错处理。
              2.品质确认完成后且住将气隙分布，拍照报错处理。
            </td>
          </tr>
        </table>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" v-print="printOption" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";
  import JsBarcode from "jsbarcode";

  export default {
    data() {
      return {
        dialogVisible: false,
        // productInfo: {},
        productInfos: [],
        ids: [],
        qixiUrl: "../../../../img/se/qixi.jpg",
        printOption: {
          id: "printProductionContent",
          preview: false,
          popTitle: "打印",
          previewPrintBtnLabel: "打印",
          clickMounted() {
          },
        },
      };
    },
    methods: {
      open(productInfos) {
        this.ids = [];
        this.productInfos = [];
        this.productInfos = JSON.parse(JSON.stringify(productInfos));
        this.dialogVisible = true;

        this.$nextTick(() => {
          this.productInfos.forEach((item) => {
            if (item.finalCustomerName) {
              item.finalCustomerName = item.finalCustomerName + "(" + item.finalCustomerOuterNo + ")";
            }
            if (item.customerName) {
              item.customerName = item.customerName + "(" + item.customerOuterNo + ")";
            }
            this.ids.push(item.pkid);
            document.getElementById("qrCode_" + item.pkid).innerHTML = "";
            this.bindQRCode(item.billNo, item.pkid);

            document.getElementById("barCodeM1_" + item.pkid).innerHTML = "";
            this.bindQRCode1(item.materialNo, item.pkid);
            // this.bindBarCode(item.materialNo, item.pkid);
          });
        });
      },

      bindQRCode(row, id) {
        let text = row;
        new QRCode(document.getElementById("qrCode_" + id), {
          text: text,
          width: 140,
          height: 140,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },
      bindQRCode1(row, id) {
        let text = row;
        new QRCode(document.getElementById("barCodeM1_" + id), {
          text: text,
          width: 50,
          height: 50,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },
      bindBarCode(row, id) {
        let text = row;
        new JsBarcode(document.getElementById("barCodeM1_" + id), row, {
          text: text,
          // width: 3,
          height: 20,
          margin: 0,
          displayValue: false,
        });
      },

      print() {
        // document.body.innerHTML = document.getElementById("printProductionCards").parentNode.innerHTML;
        // window.print();
        // window.location.reload();

        this.$http.get("basic", `taskDispatchBills/updatePrint/${this.ids}`).then(() => {
        });
        return false;
      },
    },
  };
</script>
<style lang="scss" scoped>
#printProductionCards {
  //width: 76mm;
  //height: 36mm;
  margin: 0 auto;
  margin-top: 1.5mm;
  page-break-before: always;
  font-size: 10px;

  table {
    width: 100%;
    height: 100%;

    td {
      border: 1px solid #111;
      border-right: 0;
      border-bottom: 0;
      padding: 5px 5px;
      box-sizing: border-box;
      font-size: 10px;
      //min-width: 140px;
      white-space: pre-wrap;
    }

    tr {
      width: 700px;
    }

    tr td:last-child {
      border-right: 1px solid #111;
    }

    tr:last-child td {
      border-bottom: 1px solid #111;
    }

    .el-checkbox {
      margin-right: 5px;
      top: 1px;
    }
  }
}

@media print {
  table {
    td {
      word-break: break-all;
    }
  }
}
</style>
